export const parseJSON = (str: string, defaultValues: any): any => {
  try {
    return JSON.parse(str);
  } catch (err) {
    console.error(err);
    return defaultValues;
  }
};
